import { AdminApi } from "../api"

export class Admin {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
  }
  static async createAdmin(userId, projectId) {
    const { data } = await AdminApi.createAdmin(userId, projectId);
    return new Admin(data.result)
  }
  static async removeAdmin(id){
    const { data } = await AdminApi.removeAdmin(id);
    return data
  }
  static async getAdminByProject(projectId){
    const { data } = await AdminApi.getAdminByProject(projectId);
    return data.result.map((item) => (item = new Admin(item)));
  }
}